import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, number, PieSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_FUNNEL_FORM_DATA,
    EchartsCustomPieChartProps,
    EchartsCustomPieFormData,
    CustomPieChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { convertToHexColor, getLegendObject } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsCustomPieChartProps,
): CustomPieChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      tooltipFormat,
      backgroundColor,
      labelColor,
      labelLineColor,
      labelPosition,
      labelAlignment,
      sliceColor,
      showLegend,
      legendOrientation,
      legendMargin
    }: EchartsCustomPieFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_FUNNEL_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    const seriesData: { name: string, value: number }[] = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: groupbyLabels,
        coltypeMapping: {},
      });
      return {
        name: label,
        value: number.numericToNumber(datum[metricLabel])
      };
    });
  
    const series: PieSeriesOption[] = [
      {
        name: metricLabel,
        type: 'pie',
        radius: '55%',
        roseType: 'radius',
        label: {
          color: convertToHexColor(labelColor),
          position: labelPosition,
          alignTo: labelAlignment
        },
        labelLine: {
          lineStyle: {
            color: convertToHexColor(labelLineColor)
          },
          smooth: 0.2,
          length: 10,
          length2: 20
        },
        itemStyle: {
          color: convertToHexColor(sliceColor),
          shadowBlur: 200,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        },
        animationType: 'scale',
        animationEasing: 'elasticOut',
        animationDelay: (idx) => {
          return Math.random() * 200;
        },
        // @ts-ignore
        data: seriesData.sort(function (a, b) {
          return a.value - b.value;
        }),
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      backgroundColor: convertToHexColor(backgroundColor),
      tooltip: {
        trigger: 'item',
        formatter: tooltipFormat
      },
      legend: {...getLegendObject(showLegend, legendOrientation,
        legendMargin ? legendMargin.toString() : undefined)},
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  